import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../Navbar.module.css";
import {
  AtlassianNavigation,
  PrimaryButton,
  CustomProductHome,
} from "@atlaskit/atlassian-navigation";

import logo from "../../../assets/revyz-logo.svg";
import { camelToTitle } from "../../../helpers/helpers";
const HomeNavbar = () => {
  const location = useLocation();

  const AtlassianProductHomeBackup = () => (
    <Link to="/home">
      <img
        src={logo}
        alt="Revyz data security"
        width="90px"
        height="28px"
        style={{ marginRight: "-9px" }}
      />
      <CustomProductHome
        siteTitle={
          <span>
            {location.pathname.split("/")[1] === "config-page"
              ? "Home"
              : camelToTitle(location.pathname.split("/")[1])}
          </span>
        }
      />
    </Link>
  );

  return (
    <div className={styles.header}>
      <AtlassianNavigation
        label="site"
        primaryItems={[
          <Link to="/home">
            <PrimaryButton isHighlighted={location.pathname === "/home"}>
              RDS
            </PrimaryButton>
          </Link>,

          <Link to="/home/s3">
            <PrimaryButton isHighlighted={location.pathname === "/home/s3"}>
              App logs
            </PrimaryButton>
          </Link>,
        ]}
        renderProductHome={AtlassianProductHomeBackup}
      />
    </div>
  );
};

export default HomeNavbar;
